import type CalendarFolderSearchScope from '../schema/CalendarFolderSearchScope';
import getStore from '../store/store';
import {
    getCalendarEntryByFolderId,
    getCalendarFolderId,
    isLocalCalendarEntry,
    getDefaultCalendar,
} from 'owa-calendar-cache';
import getSelectedCalendarsForUser from '../selectors/getSelectedCalendarsForUser';
import { mutator } from 'satcheljs';
import { setCalendarFoldersScope } from '../actions/searchStoreActions';
import { getUserConfiguration } from 'owa-session-store';

export let setCalendarFoldersScopeMutator = mutator(setCalendarFoldersScope, actionMessage => {
    let store = getStore();
    let folderSearchScopeList: CalendarFolderSearchScope[];

    // The very first time search session is started, we will determine the selected calendars list from the module store
    if (actionMessage.scope == null) {
        // We ignore any pre-existing calendarFoldersScope in the store, if any
        folderSearchScopeList = [];

        // For search v1 - we will search in all selected calendars
        let selectedCalendars = getSelectedCalendarsForUser(
            store.accountSmtpAddress || getUserConfiguration().SessionSettings.LogonEmailAddress
        );

        // Find the default calendar, and push it to the top of the collection (if not already first)
        let defaultCalendar = getDefaultCalendar(store.accountSmtpAddress);
        let index = -1;
        for (const calendar of selectedCalendars) {
            if (calendar.calendarId.id === defaultCalendar.calendarId.id) {
                index = selectedCalendars.indexOf(calendar);
                break;
            }
        }
        if (index > 0) {
            selectedCalendars.splice(0, 0, selectedCalendars.splice(index, 1)[0]);
        }

        // Filter out the non-local calendars
        let calendarFolderIds = selectedCalendars
            .map(c => getCalendarFolderId(c))
            .filter(id => isLocalCalendarEntry(id));

        calendarFolderIds.forEach(folderId => {
            folderSearchScopeList.push({
                folderId: folderId,
                displayName: getCalendarEntryByFolderId(folderId).CalendarName,
                isSelected: true,
            });
        });
        store.selectedCalendarsCount = calendarFolderIds.length;
    } else {
        // Initial population of calendar scopes has happened, user is manually selecting/deselecting calendars now.
        // Swapping the select status depending upon user actions
        folderSearchScopeList = store.calendarFoldersScope || [];

        // Resetting the calendarFoldersScope in store to force re-render
        store.calendarFoldersScope = [];

        let selectedScope = folderSearchScopeList.filter(
            item => item.folderId == actionMessage.scope.folderId
        )[0];
        selectedScope.isSelected = !selectedScope.isSelected;

        // On calendar surface, we never let our users to deselect all calendars.
        // Instead primary calendar gets selected by default.
        // We want to follow the same logic, when users select/deselect calendars in calendar scopes.
        store.selectedCalendarsCount = selectedScope.isSelected
            ? ++store.selectedCalendarsCount
            : --store.selectedCalendarsCount;
        if (store.selectedCalendarsCount == 0) {
            folderSearchScopeList[0].isSelected = true;
            store.selectedCalendarsCount++;
        }
    }

    store.calendarFoldersScope = folderSearchScopeList;
});
